import SsgFallback from '@components/SsgFallback'
import {getCategoriesAndProductsWeb_cached_categories} from '@data/queries/categories/__generated__/getCategoriesAndProductsWeb_cached'
import {
  getCategoriesForCPGWebsite,
  getCategoriesForWebsite
} from '@data/queries/categories/categoriesForWebsite'
import getWebsiteIdFromDomain from '@data/queries/website/websiteIdFromDomain'
import getWebsiteInitialData from '@data/queries/website/websiteInitialData'
import getWebsiteMenuInformation from '@data/queries/website/websiteMenuInformation'
import websiteSSRTranslations from '@helpers/misc/websiteSSRTranslations'
import getSsrComponentMapForOrderPage from '@helpers/ssr/getSsrComponentMapForOrderPage'
import isStore from '@helpers/websites/isStore'
import Layout from '@page-components/Layout'
import LegalInformation from '@page-components/LegalInformation'
import NoWebsite from '@page-components/NoWebsite'
import {InferGetStaticPropsType} from 'next'
import {useRouter} from 'next/router'

export default function InfoLegalPage(props: InferGetStaticPropsType<typeof getStaticProps>) {
  const router = useRouter()
  if (router.isFallback) {
    return <SsgFallback />
  }

  if (!props.website) {
    return <NoWebsite />
  }
  return (
    <Layout initialData={props.initialData}>
      <LegalInformation website={props.website} />
    </Layout>
  )
}

export const getStaticProps = async context => {
  const websiteId = await getWebsiteIdFromDomain(context.params.hostname)
  const initialData = await getWebsiteInitialData(websiteId)
  const {website, design} = await getWebsiteMenuInformation(websiteId)
  const categories: getCategoriesAndProductsWeb_cached_categories = website
    ? isStore(website.businessType)
      ? await getCategoriesForCPGWebsite({websiteId, menuId: website.defaultMenuId})
      : await getCategoriesForWebsite({websiteId, menuId: website.defaultMenuId})
    : ({items: []} as getCategoriesAndProductsWeb_cached_categories)

  const {page, componentIdToSsrProps} = await getSsrComponentMapForOrderPage(
    initialData,
    websiteId,
    context
  )

  return {
    props: {
      ...(await websiteSSRTranslations(website)),
      initialData,
      websiteId,
      website,
      design,
      categories,
      page,
      componentIdToSsrProps
    },
    revalidate: 60 * 10
  }
}

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: true
  }
}
